import gql from 'graphql-tag';

export default gql`
  query getUpdates($id: Int!) {
    getReservation(id: $id) {
      id
      ownerPickupTime
      ownerDropoffTime
      guestPickupTime
      guestDropoffTime
      categoryIds
    }
  }
`;



// WEBPACK FOOTER //
// ./src/mobxStores/Inbox/getReservationConfirmations.Q.js